import createIcon from '../../createIcon';

/**
 * @component @name ShoppingCart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxOEM2LjkgMTggNi4wMSAxOC45IDYuMDEgMjBDNi4wMSAyMS4xIDYuOSAyMiA4IDIyQzkuMSAyMiAxMCAyMS4xIDEwIDIwQzEwIDE4LjkgOS4xIDE4IDggMThaTTIgMlY0SDRMNy42IDExLjU5TDYuMjUgMTQuMDRDNi4wOSAxNC4zMiA2IDE0LjY1IDYgMTVDNiAxNi4xIDYuOSAxNyA4IDE3SDIwVjE1SDguNDJDOC4yOCAxNSA4LjE3IDE0Ljg5IDguMTcgMTQuNzVMOC4yIDE0LjYzTDkuMSAxM0gxNi41NUMxNy4zIDEzIDE3Ljk2IDEyLjU5IDE4LjMgMTEuOTdMMjEuODggNS40OEMyMS45NiA1LjM0IDIyIDUuMTcgMjIgNUMyMiA0LjQ1IDIxLjU1IDQgMjEgNEg2LjIxTDUuMjcgMkgyWk0xOCAxOEMxNi45IDE4IDE2LjAxIDE4LjkgMTYuMDEgMjBDMTYuMDEgMjEuMSAxNi45IDIyIDE4IDIyQzE5LjEgMjIgMjAgMjEuMSAyMCAyMEMyMCAxOC45IDE5LjEgMTggMTggMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShoppingCart = createIcon('ShoppingCart', [
  [
    'path',
    {
      d: 'M8 18C6.9 18 6.01 18.9 6.01 20C6.01 21.1 6.9 22 8 22C9.1 22 10 21.1 10 20C10 18.9 9.1 18 8 18ZM2 2V4H4L7.6 11.59L6.25 14.04C6.09 14.32 6 14.65 6 15C6 16.1 6.9 17 8 17H20V15H8.42C8.28 15 8.17 14.89 8.17 14.75L8.2 14.63L9.1 13H16.55C17.3 13 17.96 12.59 18.3 11.97L21.88 5.48C21.96 5.34 22 5.17 22 5C22 4.45 21.55 4 21 4H6.21L5.27 2H2ZM18 18C16.9 18 16.01 18.9 16.01 20C16.01 21.1 16.9 22 18 22C19.1 22 20 21.1 20 20C20 18.9 19.1 18 18 18Z',
      key: 'kzjln4',
    },
  ],
]);

export default ShoppingCart;
